class MediaQueries {
  constructor() {
    this.small = null
  }

  getSmall() {
    if (!this.small) {
      this.small = window.matchMedia('(min-width: 576px)')
    }
    return this.small
  }

  getLarge() {
    if (!this.large) {
      this.large = window.matchMedia('(min-width: 992px)')
    }
    return this.large
  }
}

const theInstance = new MediaQueries()
export default theInstance
